module.exports = __webpack_public_path__ + "static/luca-383bf6091a27ba48d0cdcdc66150ac01.jpg";